import {ButtonSeverity} from 'primeng/button';
import {EStatusTagDisplayMode} from '../status-tag/status-tag.component';
import {IDataCellDisplayComponent} from '../../data-cell-display/idata-cell-display/idata-cell-display.component';
import {Type} from '@angular/core';

export enum ETreeColType {
    DATA = 'DATA',
    BUTTON = 'BUTTON'
}

export enum ETreeColDataType {
    LONG_TEXT = 'LONG_TEXT',
    IMAGE = 'IMAGE',
    DATE = 'DATE',
    BOOLEAN_LABEL = 'BOOLEAN_LABEL',
    BOOLEAN_ICON = 'BOOLEAN_ICON',
    BOOLEAN_ICON_INV = 'BOOLEAN_ICON_INV',
    CHECKBOX = 'CHECKBOX',
    CONDITIONAL_CHECKBOX = 'CONDITIONAL_CHECKBOX',
    TAGS = 'TAGS',
    CHIPS = 'CHIPS',
    TEXT = 'TEXT',
    LINK = 'LINK',
    STATUS_TAG = 'STATUS_TAG',
    DATA_DISPLAY_CELL_COMPONENT = 'DATA_DISPLAY_CELL_COMPONENT'
}

export enum ETreeColFilterType {
    TEXT = 'TEXT',
    DATE = 'DATE',
    BOOLEAN = 'BOOLEAN',
    SELECT = 'SELECT',
    MULTISELECT = 'MULTISELECT'
}

export class TreeTagDef {
    constructor(
        public value: string | number | boolean,
        public label: string,
        public icon?: string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public style?: Record<string, any>,
        public tooltip?: string,
        public styleClass?: string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public iconStyle?: Record<string, any>
    ) {}
}

export class TreeColDef {
    public __iID?: number;

    constructor(
        public header: string,
        public field: string,
        public type?: ETreeColType,
        public dataType?: ETreeColDataType,
        public dataCellDisplayComponent?: Type<IDataCellDisplayComponent<unknown, unknown>>,
        public dataCellDisplayExtra?: unknown,
        public searcheable?: boolean,
        public filterable?: boolean,
        public sortable?: boolean,
        public filterType?: ETreeColFilterType,
        public filterSelectOptions?: TreeTagDef[],
        public filterSelectDefaultOption?: string,
        public tags?: TreeTagDef[],
        public statusTagDisplayMode?: EStatusTagDisplayMode,
        public statusTagLockEvalColumn?: string,
        public tooltip?: string,
        public tooltipField?: string,
        public icon?: string,
        public nodeIconSide?: 'left' | 'right',
        public customDateFormat?: string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public tdStyle?: Record<string, any>,
        public colWidth?: string,

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public fnCustomPrefixIcon?: (row: any) => string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public fnCustomData?: (row: any) => any,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public fnCellWrappingClassName?: (row: any) => string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public fnOnCellClick?: (row: any) => void,

        public buttonSeverity?: ButtonSeverity,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public fnOnButtonClick?: (row: any) => void
    ) {}
}
